/* eslint-disable semi */
import { env } from '../../../env';
/* -------------------------------------------------------------------------- */
/*                                TOKENLIFETIME                               */
/* -------------------------------------------------------------------------- */
// Contiene el tiempo de vida del token en segundos
const TOKEN_LIFE_TIME = env.VITE_TOKEN_LIFE_TIME ?? 1800;
export default TOKEN_LIFE_TIME;
